import { CheckCircle2, UploadCloud } from "lucide-react";

type Props = {
  icon: React.ReactNode;
  title: string;
  description: string;
  features: string[];
};

export function ImportComingSoon({ icon, title, description, features }: Props) {
  return (
    <div className="space-y-5">
      {/* Área de upload (visual, desabilitada) */}
      <div className="rounded-xl border-2 border-dashed border-zinc-200 bg-zinc-50/60 px-6 py-10 text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white text-zinc-400 shadow-sm">
          <UploadCloud className="h-6 w-6" />
        </div>
        <p className="mt-3 text-sm font-semibold text-zinc-700">
          Arraste um arquivo ou clique pra selecionar
        </p>
        <p className="mt-1 text-xs text-zinc-500">
          CSV, XLSX ou XLS · até 50MB
        </p>
        <button
          type="button"
          disabled
          className="mt-4 inline-flex h-9 cursor-not-allowed items-center gap-1.5 rounded-md bg-zinc-200 px-4 text-xs font-medium text-zinc-500"
        >
          <UploadCloud className="h-3.5 w-3.5" />
          Selecionar arquivo
        </button>
        <p className="mt-3 text-[10px] uppercase tracking-wider text-amber-700">
          Em desenvolvimento
        </p>
      </div>

      {/* Lista de features planejadas */}
      <div className="rounded-xl border border-zinc-200 bg-white">
        <div className="flex items-center gap-3 border-b border-zinc-100 px-4 py-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-50 text-brand-600">
            {icon}
          </div>
          <div>
            <h3 className="text-sm font-semibold text-zinc-900">{title}</h3>
            <p className="text-xs text-zinc-500">{description}</p>
          </div>
        </div>
        <div className="px-4 py-4">
          <p className="mb-3 text-[10px] font-semibold uppercase tracking-wider text-zinc-500">
            O que estará disponível
          </p>
          <ul className="space-y-1.5">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-2 text-xs text-zinc-700">
                <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-500" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
